// src/services/notificationService.js
import api from './apiClient.js'

export const notificationService = {
    /**
     * Obtenir toutes les notifications
     * @param {Object} params - Paramètres de pagination et filtres
     * @returns {Promise<Object>}
     */
    async getAllNotifications(params = {}) {
        try {
            const response = await api.get('/notifications', {
                params
            })
            return response.data
        } catch (error) {
            console.error('Erreur lors de la récupération des notifications:', error)
            throw error
        }
    },

    /**
     * Obtenir les notifications non lues
     * @returns {Promise<Object>}
     */
    async getUnreadNotifications() {
        try {
            const response = await api.get('/notifications/unread')
            return response.data
        } catch (error) {
            console.error('Erreur lors de la récupération des notifications non lues:', error)
            throw error
        }
    },

    /**
     * Obtenir le compteur de notifications non lues
     * @returns {Promise<number>}
     */
    async getUnreadCount() {
        try {
            const response = await api.get('/notifications/unread/count')
            return response.data.count || 0
        } catch (error) {
            console.error('Erreur lors de la récupération du compteur:', error)
            return 0
        }
    },

    /**
     * Marquer une notification comme lue
     * @param {string} notificationId - ID de la notification
     * @returns {Promise<Object>}
     */
    async markAsRead(notificationId) {
        try {
            const response = await api.put(`/notifications/${notificationId}/read`)
            return response.data
        } catch (error) {
            console.error('Erreur lors du marquage de la notification:', error)
            throw error
        }
    },

    /**
     * Marquer toutes les notifications comme lues
     * @returns {Promise<Object>}
     */
    async markAllAsRead() {
        try {
            const response = await api.put('/notifications/read-all')
            return response.data
        } catch (error) {
            console.error('Erreur lors du marquage de toutes les notifications:', error)
            throw error
        }
    },

    /**
     * Supprimer une notification
     * @param {string} notificationId - ID de la notification
     * @returns {Promise<Object>}
     */
    async deleteNotification(notificationId) {
        try {
            const response = await api.delete(`/notifications/${notificationId}`)
            return response.data
        } catch (error) {
            console.error('Erreur lors de la suppression de la notification:', error)
            throw error
        }
    },

    /**
     * Créer une notification de test
     * @returns {Promise<Object>}
     */
    async createTestNotification() {
        try {
            const response = await api.post('/notifications/test')
            return response.data
        } catch (error) {
            console.error('Erreur lors de la création de la notification de test:', error)
            throw error
        }
    },

    /**
     * Obtenir les préférences de notifications
     * @returns {Promise<Object>}
     */
    async getPreferences() {
        try {
            const response = await api.get('/notifications/preferences')
            return response.data
        } catch (error) {
            console.error('Erreur lors de la récupération des préférences:', error)
            throw error
        }
    },

    /**
     * Mettre à jour les préférences de notifications
     * @param {Object} preferences - Nouvelles préférences
     * @returns {Promise<Object>}
     */
    async updatePreferences(preferences) {
        try {
            const response = await api.put('/notifications/preferences', preferences)
            return response.data
        } catch (error) {
            console.error('Erreur lors de la mise à jour des préférences:', error)
            throw error
        }
    }
}

export default notificationService